import { render, staticRenderFns } from "./StatiColors.vue?vue&type=template&id=7526db50"
import script from "./StatiColors.vue?vue&type=script&lang=js"
export * from "./StatiColors.vue?vue&type=script&lang=js"
import style0 from "./StatiColors.vue?vue&type=style&index=0&id=7526db50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports